import { Link } from 'react-router-dom';

/**
 * EPN-36 — the honest, supported "blocked" state for a real Partner credential whose only Partner-channel
 * company is currently deactivated (`Company.IsActive === false`). Mirrors AccessDeniedPage's own
 * `page page--centered` / `card` layout convention rather than inventing a new one, but with its own copy
 * — AccessDeniedPage's is role-based ("you don't have permission"), not account-status-based, so its text
 * doesn't fit this case.
 * <p>
 * The session that was just issued by the credential check is revoked (see PartnerLoginPage's own
 * `logout()` call) before this renders — without that, this message would be purely cosmetic, since
 * nothing else in the app currently re-checks `Company.IsActive` (see MembershipSummary's own doc comment
 * on the backend): a visitor could otherwise just navigate to "/" and reach the normal Admin Portal anyway.
 */
export function PartnerAccountInactivePage() {
  return (
    <div className="page page--centered">
      <section className="card" data-testid="partner-account-inactive-page">
        <h1>Partner Account Inactive</h1>
        <p>Your Partner account isn&rsquo;t active right now, so we can&rsquo;t sign you in.</p>
        <p className="muted">
          If you believe this is a mistake, contact Escochex support for help reactivating your Partner
          account.
        </p>
        <p>
          <Link to="/partner-login">Back to Partner Sign In</Link>
        </p>
      </section>
    </div>
  );
}
